var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsMetric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g651"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8556_28822",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path657",
    d: "M0.916016 0.91634H23.0827V23.083H0.916016V0.91634Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8556_28822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g661",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "path663 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97913 19.0527C7.86578 20.1661 6.06067 20.1661 4.94728 19.0527C3.83392 17.9393 3.83392 16.1342 4.94728 15.0208L7.97917 11.9889C8.26118 11.7069 8.26118 11.2497 7.97917 10.9677C7.69715 10.6857 7.23992 10.6857 6.9579 10.9677L3.92601 13.9996C2.24862 15.677 2.24862 18.3966 3.92601 20.074C5.60343 21.7514 8.32301 21.7514 10.0004 20.074C10.0004 20.074 10.0004 20.074 10.0004 20.074L13.0323 17.0421C13.3143 16.7601 13.3143 16.3028 13.0323 16.0208C12.7503 15.7388 12.293 15.7388 12.011 16.0208L8.97914 19.0527L8.97913 19.0527Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g665",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "path667 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0225 13.0297C16.3045 13.3117 16.7617 13.3117 17.0437 13.0297L20.0756 9.99781C21.753 8.32042 21.753 5.6008 20.0756 3.92341C18.3982 2.246 15.6786 2.24599 14.0012 3.92341C14.0012 3.92342 14.0012 3.92342 14.0012 3.92342L10.9693 6.9553C10.6873 7.23732 10.6873 7.69456 10.9693 7.97657C11.2513 8.25859 11.7086 8.25859 11.9906 7.97657L15.0225 4.94468L15.0225 4.94467C16.1358 3.83129 17.9409 3.83129 19.0543 4.94468C20.1677 6.05804 20.1677 7.86319 19.0543 8.97654L16.0225 12.0084C15.7404 12.2904 15.7404 12.7477 16.0225 13.0297Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path671 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8796 6.88126C7.16162 6.59925 7.16162 6.14201 6.8796 5.86L5.36364 4.34403C5.08162 4.06202 4.62439 4.06202 4.34237 4.34403C4.06036 4.62605 4.06036 5.08328 4.34237 5.3653L5.85833 6.88126C6.14035 7.16328 6.59759 7.16328 6.8796 6.88126Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path675 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8796 6.88126C7.16162 6.59925 7.16162 6.14201 6.8796 5.86L5.36364 4.34403C5.08162 4.06202 4.62439 4.06202 4.34237 4.34403C4.06036 4.62605 4.06036 5.08328 4.34237 5.3653L5.85833 6.88126C6.14035 7.16328 6.59759 7.16328 6.8796 6.88126Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path679 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 8.39016C2.66602 8.78899 2.98933 9.1123 3.38816 9.1123H5.53203C5.93086 9.1123 6.25417 8.78899 6.25417 8.39016C6.25417 7.99133 5.93086 7.66802 5.53203 7.66802H3.38816C2.98933 7.66802 2.66602 7.99133 2.66602 8.39016Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path683 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 8.39016C2.66602 8.78899 2.98933 9.1123 3.38816 9.1123H5.53203C5.93086 9.1123 6.25417 8.78899 6.25417 8.39016C6.25417 7.99133 5.93086 7.66802 5.53203 7.66802H3.38816C2.98933 7.66802 2.66602 7.99133 2.66602 8.39016Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path687 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39011 6.25488C8.78894 6.25488 9.11226 5.93157 9.11226 5.53274V3.38887C9.11226 2.99004 8.78894 2.66673 8.39011 2.66673C7.99128 2.66673 7.66797 2.99004 7.66797 3.38887V5.53274C7.66797 5.93157 7.99128 6.25488 8.39011 6.25488Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path691 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39011 6.25488C8.78894 6.25488 9.11226 5.93157 9.11226 5.53274V3.38887C9.11226 2.99004 8.78894 2.66673 8.39011 2.66673C7.99128 2.66673 7.66797 2.99004 7.66797 3.38887V5.53274C7.66797 5.93157 7.99128 6.25488 8.39011 6.25488Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path695 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.655 19.6567C19.937 19.3746 19.937 18.9174 19.655 18.6354L18.139 17.1194C17.857 16.8374 17.3998 16.8374 17.1178 17.1194C16.8357 17.4014 16.8357 17.8587 17.1178 18.1407L18.6337 19.6567C18.9157 19.9387 19.373 19.9387 19.655 19.6567Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path699 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.655 19.6567C19.937 19.3746 19.937 18.9174 19.655 18.6354L18.139 17.1194C17.857 16.8374 17.3998 16.8374 17.1178 17.1194C16.8357 17.4014 16.8357 17.8587 17.1178 18.1407L18.6337 19.6567C18.9157 19.9387 19.373 19.9387 19.655 19.6567Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path703 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6069 21.332C16.0057 21.332 16.3291 21.0087 16.3291 20.6099V18.466C16.3291 18.0672 16.0057 17.7439 15.6069 17.7439C15.2081 17.7439 14.8848 18.0672 14.8848 18.466V20.6099C14.8848 21.0087 15.2081 21.332 15.6069 21.332Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path707 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6069 21.332C16.0057 21.332 16.3291 21.0087 16.3291 20.6099V18.466C16.3291 18.0672 16.0057 17.7439 15.6069 17.7439C15.2081 17.7439 14.8848 18.0672 14.8848 18.466V20.6099C14.8848 21.0087 15.2081 21.332 15.6069 21.332Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path711 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7441 15.6079C17.7441 16.0068 18.0675 16.3301 18.4663 16.3301H20.6102C21.009 16.3301 21.3323 16.0068 21.3323 15.6079C21.3323 15.2091 21.009 14.8858 20.6102 14.8858H18.4663C18.0675 14.8858 17.7441 15.2091 17.7441 15.6079Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path715 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7441 15.6079C17.7441 16.0068 18.0675 16.3301 18.4663 16.3301H20.6102C21.009 16.3301 21.3323 16.0068 21.3323 15.6079C21.3323 15.2091 21.009 14.8858 20.6102 14.8858H18.4663C18.0675 14.8858 17.7441 15.2091 17.7441 15.6079Z",
    fill: "#7C7C7C"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsMetric);
export default __webpack_public_path__ + "static/media/controlsMetric.77eed5d1f8d761658919a28116ef9224.svg";
export { ForwardRef as ReactComponent };